/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Psod_Contact_AfterInputs */

const fr_psod_contact_after = /** @type {(inputs: Psod_Contact_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` avec le rapport d'erreur ci-dessous.`)
};

const en_psod_contact_after = /** @type {(inputs: Psod_Contact_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` with the error report below.`)
};

/**
* | output |
* | --- |
* | "with the error report below." |
*
* @param {Psod_Contact_AfterInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const psod_contact_after = /** @type {((inputs?: Psod_Contact_AfterInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Psod_Contact_AfterInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_psod_contact_after(inputs)
	return en_psod_contact_after(inputs)
});